export const environment = {
  production: true,
  appVersion: '1.0.4',
  appUpdateCheckIntervalms: -1,
  apiBasePath: null, // if null, configuration will use this client app's basePath 
  googleClientId: '986040536356-q6v1600ga55e91a430kfmtde7l8o6jii.apps.googleusercontent.com',
  microsoftClientId: '199e2269-5169-4184-a8d6-96fb8f78ed73'
};
